<template>
	<div v-if="isLoading" class="loading-overlay">
		<div class="spinner-border text-primary" role="status">
			<span class="visually-hidden">Caricamento...</span>
		</div>
		<div class="loading-text">Caricamento in corso...</div>
	</div>
	<SimpleModal v-model="showLandingModal" title="" :buttons="['OK']" @chose="() => {
		this.showLandingModal = false;
		this.$router.push({ name: 'questions.list' });
	}">
		<p>Segnalazione inviata con successo</p>
	</SimpleModal>
	<div class="d-flex" ref="articleCard">
		<!---DIff Tooltip-->
		<div v-if="this.tooltip.show" :style="tooltipStyle" class="diff-tooltip">
			<div v-if="tooltip.type === 'del'" class="tooltip-content">
				<strong>Testo rimosso</strong>
				<div class="tooltip-version">dalla versione: {{ this.versioning.from }}</div>
			</div>
			<div v-else-if="tooltip.type === 'ins'" class="tooltip-content">
				<strong>Testo aggiunto</strong>
				<div class="tooltip-version">nella versione: {{ this.versioning.to }}</div>
			</div>
		</div>
		<!----->
		<div class="p-2 shadow group-bar bg-white" :class="{ 'd-none': sidebarCollapsed }">
			<div class="nav-sidebar ms-auto reactive-top">
				<div style="display:inline-table;">
					<a v-if="localArticle.versions.length > 0" @click="scrollToElement('articleCard')"
						data-bs-toggle="tooltip" title="Articolo"
						class="nav-link d-flex align-items-center mb-2 p-2 d-flex">
						<i class="bi bi-file-earmark-text icon icon-sm icon-primary me-2 ms-2"></i>
						<span class="d-none d-md-block sidebar-label">Articolo</span>
					</a>
					<a v-if="localArticle.opinions && localArticle.opinions.length > 0"
						@click="scrollToElement('opinionCards')" data-bs-toggle="tooltip" title="Pareri"
						class="nav-link d-flex align-items-center mb-2 p-2">
						<i class="bi bi-pin icon icon-sm icon-primary me-2 ms-2"></i>
						<span class="d-none d-md-block sidebar-label">Pareri</span>
					</a>
				</div>
			</div>
		</div>


		<!-- Pulsante navigazione articolo precedente -->
		<button
			v-if="false && this.localArticle.last && this.localArticle.last.article && this.localArticle.last.version"
			class="back-button btn btn-icon btn-outline-primary rounded-circle align-items-center justify-content-center"
			@click="navigateToArticle(this.localArticle.last.article.id, this.localArticle.last.version)"
			title="Vai all'articolo precedente">
			<!--<svg class="icon icon-primary" style="min-width:1.2rem">
				<use :href="this.$root.baseURL + '/bootstrap-italia/dist/svg/sprites.svg#it-chevron-left'"></use>
			</svg>-->
			<span class="visually-hidden">Articolo precedente</span>
		</button>

		<!-- Pulsante navigazione articolo successivo -->
		<button
			v-if="false && this.localArticle.next && this.localArticle.next.article && this.localArticle.next.version"
			class="next-button btn btn-icon btn-outline-primary rounded-circle align-items-center justify-content-center"
			@click="navigateToArticle(this.localArticle.next.article.id, this.localArticle.next.version)"
			title="Vai all'articolo successivo">
			<!--<svg class="icon icon-primary" style="min-width:1.2rem">
				<use :href="this.$root.baseURL + '/bootstrap-italia/dist/svg/sprites.svg#it-chevron-right'"></use>
			</svg>-->
			<span class="visually-hidden">Articolo successivo</span>
		</button>

		<!-- Toggle button for sidebar -->
		<button @click="toggleSidebar" class="btn btn-sm shadow position-fixed sidebar-toggle mb-2">
			<i class="bi bi-chevron-right" v-if="sidebarCollapsed"></i>
			<i class="bi bi-chevron-left" v-if="!sidebarCollapsed"></i>
		</button>
		<div class="flex-grow-1 reactive-padding"
			:style="{ maxWidth: sidebarCollapsed ? 'auto' : 'calc(100% - 56px - 1em)' }">
			<transition-group name="fade-transition" mode="out-in">
				<div v-if="loading || localArticle.versions.length == 0">
					<LoadingModal message="Caricamento dell'articolo in corso..." />
				</div>
				<div class="container my-5" id="article-card" v-else>
					<BreadcrumbNode class="d-block d-lg-none" :article="this.$root.breadcrumbData.article"
						:section="this.$root.breadcrumbData.section" :background="'light'" />
					<div class="row">
						<div class="col-12">
							<div id="article-title-section" class="d-flex text-center justify-content-around">

								<button id="article-back-button"
									v-if="localArticle.last && localArticle.last.article && localArticle.last.version"
									class="btn btn-icon p-2 align-items-center justify-content-center text-primary"
									@click="navigateToArticle(localArticle.last.article.id, localArticle.last.version)"
									title="Vai all'articolo precedente">
									<i class="bi bi-chevron-left icon icon-sm icon-primary me-2 ms-2"
										style="min-width:1.2rem; scale: 1.8"></i>
									<!--<svg class="icon icon-primary" style="min-width:1.2rem; scale: 1.8">
										<use
											:href="this.$root.baseURL + '/bootstrap-italia/dist/svg/sprites.svg#it-chevron-left'">
										</use>
									</svg>-->

									<span class="ms-2 navigation-button-cardinality d-flex">
										{{ localArticle.last.article.cardinality }} <small
											class="my-auto ms-2">Prec.</small>
									</span>
									<span class="visually-hidden">Articolo precedente</span>
								</button>
								<h1 id="article-title" class="flex-grow-1">{{ localArticle.activeVersion.title ??
									localArticle.title }}</h1>
								<button id="article-next-button"
									v-if="localArticle.next && localArticle.next.article && localArticle.next.version"
									class="btn btn-icon ms-auto p-2 align-items-center justify-content-center text-primary"
									@click="navigateToArticle(localArticle.next.article.id, localArticle.next.version)"
									title="Vai all'articolo successivo">
									<span class="me-2 navigation-button-cardinality d-flex">
										{{ localArticle.next.article.cardinality }} <small
											class="my-auto ms-2">Succ.</small>
									</span>
									<i class="bi bi-chevron-right" style="min-width:1.2rem; scale: 1.8"></i>
									<!--<svg class="icon icon-primary" style="min-width:1.2rem; scale: 1.8">
										<use
											:href="this.$root.baseURL + '/bootstrap-italia/dist/svg/sprites.svg#it-chevron-right'">
										</use>
									</svg>-->
									<span class="visually-hidden">Articolo successivo</span>
								</button>
							</div>
							<button class="btn btn-sm d-flex align-items-center text-primary ms-auto" type="button"
								@click="showSwitchArticle = !showSwitchArticle">
								<i class="bi bi-currency-exchange icon icon-sm icon-primary me-2 ms-2"
									aria-hidden="true"></i>
								Cambia articolo
							</button>

							<label class="active" for="dateStandard"><b>Stai visualizzando l'articolo valido
									al:</b></label>
							<input @change="changeDate($event)" class="form-control" type="date" id="dateStandard"
								name="dateStandard">
							<div class="mt-2" v-if="localArticle.versions.length > 1">
								<a href="#" @click.prevent="versioning.show = !versioning.show">
									Confronta versioni
								</a>

								<br class="d-md-none">

								<Transition>
									<div v-if="versioning.show" class="d-flex align-items-end mt-3">

										<div class="row flex-grow-1 g-3">
											<!-- Versione 1 -->
											<div class="col-12 col-md-6">
												<label class="form-label fw-bold">
													Confronta versione decreto
												</label>
												<select v-model="versioning.v1" class="form-select">
													<option value="">Seleziona...</option>
													<option
														v-for="version in localArticle.versions.filter(x => x.id !== versioning.v2)"
														:key="version.id" :value="version.id">
														{{ version.version.title }}
													</option>
												</select>
											</div>

											<!-- Versione 2 -->
											<div class="col-12 col-md-6">
												<label class="form-label fw-bold">
													Con
												</label>
												<select v-model="versioning.v2" class="form-select">
													<option value="">Seleziona...</option>
													<option
														v-for="version in localArticle.versions.filter(x => x.id !== versioning.v1)"
														:key="version.id" :value="version.id">
														{{ version.version.title }}
													</option>
												</select>
											</div>
										</div>

										<!-- Pulsante confronta -->
										<button type="button" class="btn btn-primary btn-lg rounded-circle ms-4 shadow"
											:disabled="!versioning.v1 || !versioning.v2" @click="compare"
											title="Confronta versioni">
											<i class="bi bi-arrow-left-right"></i>
										</button>

									</div>
								</Transition>
							</div>
							<div class="dropdown p-2 bg-white shadow-sm mt-4 rounded d-md-flex justify-content-between"
								data-bs-display="static">
								<div class="d-flex flex-row flex-grow-1 justify-content-between">
									<div v-if="this.versioning.diff">
										<a class="dropdown-toggle text-break" type="button" @click="clearCompare"
											aria-expanded="false">
											<i class="bi bi-file-earmark-text icon icon-sm icon-primary me-2 ms-2"></i>
											<span>
												{{ this.versioning.from }}
											</span>
											<i class="bi bi-arrow-right"></i>
											<span>
												{{ this.versioning.to }}
											</span>
										</a>
									</div>
									<div v-else>
										<a class="dropdown-toggle d-flex align-items-center" type="button"
											data-bs-toggle="dropdown" aria-expanded="false">
											<i class="bi bi-chevron-down icon icon-sm icon-primary me-2 ms-2"></i>
											<span style="white-space:pre-wrap" class="text-break">
												{{ localArticle.activeVersion.version.title }} valido dal {{
													this.defaultDateFormatter.format(localArticle.activeVersion.validity_start)
												}} {{
													!isToday(localArticle.activeVersion.validity_end) ? "al " +
														this.defaultDateFormatter.format(localArticle.activeVersion.validity_end)
														: '' }}
											</span>
										</a>

										<!-- QUI ho messo scrollable-menu -->
										<ul class="dropdown-menu scrollable-menu">
											<li v-for="version in localArticle.versions" :key="version.id">
												<button class="dropdown-item text-primary"
													@click="this.setArticleVersion(version)"
													:class="version.id == localArticle.activeVersion.id ? 'text-muted disabled' : ''">
													Versione {{ version.version.title }}
												</button>
											</li>
										</ul>
									</div>
								</div>

								<a v-if="this.localArticle.opinions && this.localArticle.opinions.length > 0"
									class="dropdown-toggle" type="button" data-bs-toggle="dropdown"
									aria-expanded="false">
									<i class="bi bi-chevron-down"></i>
									Sono presenti pareri
									<span class="badge bg-danger ms-2">{{ this.localArticle.opinions.length }}</span>
								</a>

								<ul class="dropdown-menu scrollable-menu" style="max-width:calc(100vw - 30%)">
									<li v-for="opinion in this.localArticle.opinions" :key="opinion.id">
										<button type="button" @click="this.scrollToElement('#quesito-' + opinion.id)"
											class="dropdown-item text-primary text-wrap text-break">
											{{ opinion.object }}
										</button>
									</li>
								</ul>
							</div>

							<hr class="my-0">
							<div v-if="this.versioning.diff || this.versioning.diff2">
								<div @mousemove="showTooltip($event)" @mouseleave="hideTooltip"
									:key="versioning.diffKey" v-html="sanitize(parsedArticleDiff)"
									class="p-4 shadow rounded diff-content"></div>
							</div>
							<div v-else>
								<div id="article-content" class="p-4 shadow rounded" v-html="sanitize(parsedArticleContent)">
								</div>
							</div>
						</div>
						<div class="mt-3" ref="opinionCards">
							<div class="mt-3" v-for="opinion in this.localArticle.opinions" :key="opinion.id">
								<OpinionCard :id="opinion.id" :emission_date="opinion.created_at"
									:arguments="opinion.topics" :subject="opinion.object" :question="opinion.originalText"
									:answer="opinion.opinion" />
							</div>
						</div>


					</div>
				</div>
			</transition-group>
		</div>
		<SwitchToArticle :show="showSwitchArticle" @close="showSwitchArticle = false"
			@article-selected="onArticleSelected" />
	</div>
	<!-- Toast per notifiche -->
	<div class="position-fixed top-0 end-0 p-3" style="z-index: 10000">
		<div id="articleToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
			<div class="toast-header" :class="toastType ? 'bg-' + toastType : ''">
				<strong class="me-auto text-white">Notifica</strong>
				<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
			</div>
			<div class="toast-body">
				{{ toastMessage }}
			</div>
		</div>
	</div>
</template>

<style>
strong {
	font-weight: bold !important;
}

mark {
	display: block !important;
}

.alist>li {
	margin-left: 0.5rem !important;
	/* Equivalente a Bootstrap .ms-2 */
	margin-top: 0.25rem !important;
	/* Equivalente a Bootstrap .mt-1 */
}

.fixed-icon {
	min-width: 32px;
	min-height: 32px;
}

.next-button {
	position: fixed;
	top: 50%;
	right: 1rem;
	transform: translateY(-50%);
	width: 48px;
	height: 48px;
	z-index: 1;
	transition: all 0.3s ease;
	box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.back-button {
	position: fixed;
	top: 50%;
	left: 1rem;
	transform: translateY(-50%);
	width: 48px;
	height: 48px;
	z-index: 1;
	transition: all 0.3s ease;
	box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.next-button>svg,
.back-button>svg {
	scale: 1.5;
}

.navigation-button-cardinality {
	font-size: 1.3rem;
	margin-top: auto;
	margin-bottom: auto;
}

@media (max-width: 768px) {
	.next-button {
		display: none !important;
	}

	.back-button {
		display: none !important;
	}

	#article-title {
		font-size: 28px;
		line-height: 1em;
	}
}

.next-button:hover,
.back-button:hover {
	box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
	transform: translateY(-50%) scale(1.05);
}

#article-content * {
	font-family: var(--bs-body-font-family);
	font-size: var(--bs-body-font-size);
	font-weight: var(--bs-body-font-weight);
	line-height: var(--bs-body-line-height);
	color: var(--bs-body-color);
	text-align: var(--bs-body-text-align);
	background-color: var(--bs-body-bg);
	-webkit-text-size-adjust: 100%;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0)
}

#article-content a {
	color: #00468b
}

#article-content a:visited {
	color: purple;
}

#article-content table {
	width: 100%;
	margin-bottom: 1rem;
	border-collapse: collapse;
}

#article-content table th,
#article-content table td {
	padding: 0.75rem;
	vertical-align: top;
	border: 1px solid #dee2e6;
}

#article-content table thead th {
	vertical-align: bottom;
	border-bottom: 2px solid #dee2e6;
	background-color: #f8f9fa;
}
</style>

<script>
import { ref } from 'vue'
import { sanitize } from '../../utils/sanitize';
//import * as bootstrap from 'bootstrap'
import { ArticleNode } from '../../classes/tree'
import showdown from 'showdown';

import RelatedTable from '../partials/RelatedTable.vue'
import OpinionCard from '../partials/OpinionCard.vue'
import FlashCards from '../partials/FlashCards.vue';
import LoadingModal from '../partials/LoadingModal.vue'
import BreadcrumbNode from '../navigator/BreadcrumbNode.vue'
import SwitchToArticle from '../partials/SwitchToArticle.vue'
import SimpleModal from '../common/SimpleModal.vue';

export default {
	name: "ArticleView",
	components: {
		OpinionCard,
		FlashCards,
		LoadingModal,
		BreadcrumbNode,
		RelatedTable,
		SwitchToArticle,
		SimpleModal
	},
	props: {
		article: String,
		section: String,
		version: String
	},
	data() {
		return {
			content: null,
			dateFilter: "",
			defaultDateFormatter: new Intl.DateTimeFormat('it-IT', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit'
			}),
			calendarDateFormatter: new Intl.DateTimeFormat('en-CA', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit'
			}),
			versioning: {
				show: false,
				v1: "",
				v2: "",
				diff: undefined,
				from: "",
				to: "",
				listCounter: 0
			},
			localVersion: 0,
			localArticle: {
				versions: [],
				activeVersion: {
					version: {
						legislation: {

						}
					}
				},
				flashcards: [],
				opinions: [],
				mindmap: []
			},
			related_content: [],
			showSwitchArticle: false,
			sidebarCollapsed: localStorage.getItem('articleSidebarCollapsed') === 'true' ? true : false,
			tooltip: {
				show: false,
				tooltipX: 0,
				tooltipY: 0,
				type: null, // 'del' o 'ins'
				text: null
			},
			toastMessage: '',
			toastType: '',
			loading: true,
			footerAnswer: null,
			showLandingModal: false,
			isLoading: false
		}
	},
	computed: {
		/**parsedArticleContent() {
			if (!this.localArticle?.activeVersion?.content) return '';
			return this.localArticle.activeVersion.content.replace(
				/\[([^\]]+)\]\(([^)]+)\)/g,
				'<a href="$2">$1</a>'
			);
		},*/
		parsedArticleContent() {
			if (!this.localArticle?.activeVersion?.content) return '';

			return this.localArticle.activeVersion.content.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (match, text, url) => {
				try {
					const u = new URL(url, window.location.origin);
					const params = new URLSearchParams(u.search);

					if (params.has('article') && params.has('version')) {
						return `<a href="${url}">${text}</a>`;
					} else {
						 return text;
					}
				} catch (e) {
					return text;
				}
			});
		},
		parsedArticleDiff() {
			if (!this.versioning.diff) return '';

			return this.versioning.diff.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (match, text, url) => {
				try {
					const u = new URL(url, window.location.origin); // costruisce un URL valido
					const params = new URLSearchParams(u.search);
					if (params.has('article') && params.has('version')) {
						return `<a href="${url}">${text}</a>`;
					} else {
						return text;
					}
				} catch (e) {
					return text;
				}
			});
		},
		tooltipStyle() {
			return {
				position: 'fixed',
				top: `${this.tooltip.tooltipY + 10}px`,
				left: `${this.tooltip.tooltipX + 10}px`,
				background: '#333',
				color: '#fff',
				padding: '8px 12px',
				borderRadius: '4px',
				fontSize: '12px',
				pointerEvents: 'none',
				zIndex: 9999,
				boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
				maxWidth: '250px'
			};
		}
	},
	watch: {
		$route() {
			this.loadArticle();
		}
	},
	methods: {
		stripHtml(input) {
			if (!input) return "";
			if (!input.includes("<")) return input;

			const div = document.createElement("div");
			div.innerHTML = input;
			return div.textContent || div.innerText || "";
		},
		sanitize(html) {
			return sanitize(html);
		},
		parseLinks(text) {
			return text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>');
		},
		goToArticles() {
			this.$root.breadcrumbData = {
				article: null,
				section: null
			};
			this.$router.push({ path: '/articles' });
		},
		handleInternalArticleLinks(e) {
			const link = e.target.closest('a');
			if (!link) return;

			const url = new URL(link.href, window.location.origin);

			if (url.pathname === "/index.html" && url.searchParams.get("article")) {
				e.preventDefault();

				const article = url.searchParams.get("article");
				const version = url.searchParams.get("version") || undefined;


				this.$router.push({ path: '/index.html', query: { article: article, version: version } }).then(async () => {
					await this.loadArticle();
				});
			}
		},
		async handleFooterChoice() {
			if (this.footerAnswer === "no") {
				const selectedArticleId = this.localArticle?.id || null;
				const selectedVersionId = this.localArticle?.activeVersion?.version?.id || null;
				const activeVersionId = this.localArticle?.activeVersion?.id || null;
				this.$router.push({
					name: "questions.new",
					query: { article: selectedArticleId, version: selectedVersionId, activeVersionId: activeVersionId }
				});
			}

			else {
				try {
					const token = localStorage.getItem('token');
					const url = new URL(`${this.$root.config.VITE_APP_BACKOFFICE_URL}/user-feedback`);

					const payload = {
						legislation_id: this.localArticle?.activeVersion?.version?.id,
						user_id: this.$root.user?.sub,
						article_id: this.localArticle?.id
					};

					const response = await fetch(url.toString(), {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': token ? `Bearer ${token}` : ''
						},
						credentials: 'include',
						body: JSON.stringify(payload)
					});

					if (!response.ok) {
						throw new Error('Errore nell’invio della segnalazione');
					}

					this.showLandingModal = true;

				} catch (error) {
					console.error(error);
					alert('Si è verificato un errore, riprova.');
				}
			}
		},

		showTooltip(event) {
			// Calcola la posizione corretta del tooltip
			const x = event.clientX;
			const y = event.clientY;

			// Verifica il tipo di elemento su cui è il mouse
			if (event.target.tagName === 'DEL') {
				// Estrai il testo dell'elemento
				const text = event.target.textContent.trim();

				// Mostra il tooltip solo se non è già visibile o se è cambiato l'elemento
				if (!this.tooltip.show || this.tooltip.type !== 'del' || this.tooltip.text !== text) {
					this.tooltip.show = true;
					this.tooltip.type = 'del';
					this.tooltip.text = text;
				}

				// Aggiorna sempre la posizione
				this.tooltip.tooltipX = x;
				this.tooltip.tooltipY = y;

				// Evita di loggare in produzione
				if (process.env.NODE_ENV !== 'production') {
					console.log("Elemento rimosso: ", this.versioning.from);
				}
			} else if (event.target.tagName === 'INS') {
				// Estrai il testo dell'elemento
				const text = event.target.textContent.trim();

				// Mostra il tooltip solo se non è già visibile o se è cambiato l'elemento
				if (!this.tooltip.show || this.tooltip.type !== 'ins' || this.tooltip.text !== text) {
					this.tooltip.show = true;
					this.tooltip.type = 'ins';
					this.tooltip.text = text;
				}

				// Aggiorna sempre la posizione
				this.tooltip.tooltipX = x;
				this.tooltip.tooltipY = y;

				// Evita di loggare in produzione
				if (process.env.NODE_ENV !== 'production') {
					console.log("Elemento aggiunto: ", this.versioning.to);
				}
			} else {
				// Se il mouse è su un altro elemento, nascondi il tooltip
				this.tooltip.show = false;
			}
		},

		hideTooltip() {
			this.tooltip.show = false;
			this.tooltip.text = null;
		},

		toggleSidebar() {
			this.sidebarCollapsed = !this.sidebarCollapsed;
			// Store the sidebar state in localStorage to persist between page reloads
			localStorage.setItem('articleSidebarCollapsed', this.sidebarCollapsed);
		},
		async compare() {
			if (this.versioning.v1 !== '' && this.versioning.v2 !== '') {
				this.isLoading = true;
				this.versioning.diff = '...';
				this.versioning.from = this.localArticle.versions.filter((x) => x.id == this.versioning.v1)[0].version.title;
				this.versioning.to = this.localArticle.versions.filter((x) => x.id == this.versioning.v2)[0].version.title;
				const response = await this.$root.$api.get(
					`/article/compare/${this.localArticle.id}/${this.versioning.v1}/${this.versioning.v2}`
				);
				if (response) {
					try {
						const result = response.data;
						if (result.status === "success") {
							this.versioning.diff = this.b64DecodeUnicode(result.content);
							this.versioning.diffKey = Date.now();
							console.log(this.versioning.diff);
						} else {
							console.error("Confronto fallito, status:", result.status);
							this.versioning.diff = "Errore nel confronto";
						}
					} catch (err) {
						console.error("Errore durante il parsing della risposta JSON:", err);
						this.versioning.diff = "Errore durante il confronto";
					}

				}
			}
			this.isLoading = false;
		},
		collapseTag(str) {
			if (str.includes('<b class="text-success">')) {
				return '<b class="text-success">' + str.replaceAll('<b class="text-success">', '').replaceAll('</b>', '') + "</b>"
			}
			if (str.includes('<s class="text-danger text-decoration-line-through">')) {
				return '<s class="text-danger text-decoration-line-through">' + str.replaceAll('<s class="text-danger text-decoration-line-through">', '').replaceAll('</s>', '') + '</s>'
			}

			return str
		},
		markdownToHTML(string) {
			const converter = new showdown.Converter({ tables: true });
			let html = converter.makeHtml(string).replaceAll('<table>', '<table class="table">').replaceAll('href="/', 'href="' + this.$root.baseURL + "/");
			return html
		},
		convertOrderedListToStaticList(htmlString) {
			let tempDiv = document.createElement("div");
			tempDiv.innerHTML = htmlString;

			let olElements = tempDiv.querySelectorAll("ol");
			if (olElements.length == 0) return htmlString;

			olElements.forEach((olElement, index) => {
				let startIndex = 0;
				if (olElement.getAttribute('start')) {
					startIndex = parseInt(olElement.getAttribute('start')) - 1;
				}
				let listItems = olElement.querySelectorAll("li");
				let newContent = "";

				listItems.forEach((li, _index) => {
					let liContent = li.innerHTML.replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span><br><br>');
					newContent += `${startIndex + _index + 1}. ${liContent}\n`; // Aggiunge la numerazione fissa
				});

				olElements[index].outerHTML = newContent;
			})
			return tempDiv.innerHTML;
		},
		clearCompare() {
			this.versioning.diff = undefined
			this.versioning.from = ""
			this.versioning.to = ""
		},
		scrollToElement(target, options = { behavior: 'smooth', block: 'start', inline: 'nearest' }, withOffset = true) {
			let element = null;

			if (typeof target === 'string') {
				if (this.$refs[target]) {
					element = this.$refs[target];
				} else {
					element = document.querySelector(target);
				}
			} else if (target && typeof target === 'object') {
				element = target;
			}

			if (element) {
				const scrollContainer = element.closest('.modal-body') || document.documentElement;

				const offsetTop = element.offsetTop;

				const heroHeight = scrollContainer === document.documentElement && withOffset
					? (document.querySelector('#header')?.offsetHeight || 0)
					: 0;

				scrollContainer.scrollTo({
					top: offsetTop - heroHeight,
					behavior: options.behavior
				});
			}
		},

		/**
		 * Mostra un toast di notifica utilizzando Bootstrap Italia
		 * @param {string} message - Il messaggio da mostrare nel toast
		 * @param {string} type - Il tipo di toast (primary, success, danger, warning)
		 */
		showToast(message, type = 'primary') {
			this.toastMessage = message;
			this.toastType = type;

			// Utilizzo l'API di Bootstrap per mostrare il toast
			const toastEl = document.getElementById('articleToast');
			if (toastEl) {
				const toast = new bootstrap.Toast(toastEl, {
					delay: 5000 // Durata in millisecondi
				});
				toast.show();
			}
		},
		changeDate(event) {
			this.dateFilter = event.currentTarget.value
			let searchingDate = new Date(this.dateFilter)
			if (searchingDate > new Date()) {
				searchingDate = new Date()
			}
			this.loadArticle(this.dateFilter, undefined, false, () => {
				this.showToast('Data non valida', 'danger')
			}, () => {
				// Convertiamo la data nel formato italiano (d/m/Y)
				const dateParts = this.dateFilter.split('-');
				if (dateParts.length === 3) {
					const formattedDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
					this.showToast('Contenuto dell\'articolo valido alla data: ' + formattedDate, 'success');
				} else {
					this.showToast('Contenuto dell\'articolo valido alla data: ' + this.dateFilter, 'success');
				}
			});
		},
		async loadArticle(validity_date = null, version = undefined, redirectOnFail = true, failCallback = null, successCallback = null) {
			// Assicuriamoci che i contenuti siano caricati una sola volta a livello globale
			// prima di procedere con il caricamento dell'articolo
			this.loading = true;
			if (!this.$root.contentTree) {
				await this.$root.fetchContents();
			}

			try {
				// Utilizziamo il metodo globale per caricare l'articolo
				// Questo previene chiamate duplicate anche se il componente viene ricreato
				//const articleId = Number(this.$route.params.article); // Laravel vuole int
				//const versionId = this.$route.params.version || version?.id || this.version;
				const articleParam = this.$route.params.article;
				const articleQuery = this.$route.query.article;

				const articleId = articleParam ? Number(articleParam) :
					articleQuery ? Number(articleQuery) : null;

				if (!articleId) {
					this.loading = false;
					return;
				}

				const versionParam = this.$route.params.version;
				const versionQuery = this.$route.query.version;

				let versionId = versionParam ||
					versionQuery ||
					version?.id ||
					this.version;

				if (version) {
					versionId = version.id.toString();
				}
				console.log("");
				const result = await this.$root.fetchArticle(articleId, versionId, validity_date);

				if (result && result.status === "success") {

					this.localArticle = new ArticleNode(
						result.article.id,
						result.article.current_version.title,
						"article",
						result.article
					);

					this.localArticle.flashcards = result.article.flashcards;
					this.localArticle.mindmap = result.article.mindmap;
					// eslint-disable-next-line no-empty
					//this.localArticle.opinions = result.article.opinions.map((o) => { try { o.content = JSON.parse(o.content) } catch (e) { } return o });

					this.localArticle.opinions = result.article.opinions.map(o => {
						try {
							//o = JSON.parse(o);

							["answer", "text" ,"opinion"].forEach(field => {
								if (o[field]) {
									o[field] = this.stripHtml(o[field]);
								}
							});
						} catch (e) {
							console.log("Errore durante il parsing dell'opinione", o);
						}
						return o;
					});

					this.localArticle.activeVersion = this.localArticle.versions.filter(x => x.id == result.article.current_version.id)[0];
					this.localArticle.activeVersion.content = this.b64DecodeUnicode(result.article.content);
					this.localArticle.related = result.article.related;
					this.localArticle.next = result.article.next;
					this.localArticle.last = result.article.last;

					//imposta la versione 
					if (!version) {
						version = versionId;
					}
					if (version) {
						let current_version = this.localArticle.versions.filter((v) => { return v.id == version.id });
						if (current_version.length > 0) {
							version = current_version.at(0);
						}
					}

					await this.$nextTick();
					this.$root.loadBreadcrumb(this.localArticle);
					if (successCallback) {
						successCallback();
					}
				}
			} catch (error) {
				console.error('Error in ArticleView.loadArticle:', error);
				if (redirectOnFail) {
					window.location = this.$root.baseURL;
				}
				if (failCallback) {
					failCallback();
				}
			} finally {
				this.loading = false;
			}
		},
		updateDateFilter() {
			this.dateFilter = this.calendarDateFormatter.format(this.localArticle.activeVersion.validity_end)
		},
		isToday(date) {
			if (!date) {
				return true;
			}
			const today = new Date();

			return date.getFullYear() === today.getFullYear() &&
				date.getMonth() === today.getMonth() &&
				date.getDate() === today.getDate();
		},
		paragraphsToMarkdown(paragraphs) {
			return paragraphs.map(p => p.content).join('\n\n');
		},
		async setArticleVersion(version, updateDate = true) {
			// Utilizziamo il metodo loadArticle che ora usa il fetchArticle globale
			await this.loadArticle(null, version);
		},
		b64DecodeUnicode(str) {
			return decodeURIComponent(atob(str).split('').map(function (c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		},
		updateRelated(event) {
			this.localArticle.related = event;
		},
		async navigateToArticle(articleId, versionId) {
			this.$router.push({ path: '/index.html', query: { article: articleId, version: versionId } }).then(async () => {
				await this.loadArticle();
			});
		},
		async onArticleSelected({ articleId, versionId }) {
			this.showSwitchArticle = false;
			await this.$router.push({ path: '/index.html', query: { article: articleId, version: versionId } });
			await this.loadArticle();
		},
	},
	async mounted() {
		// Load sidebar collapsed state from localStorage
		const savedState = localStorage.getItem('articleSidebarCollapsed');
		if (savedState !== null) {
			this.sidebarCollapsed = savedState === 'true';
		}

		await this.loadArticle()

		document.body.addEventListener('click', this.handleInternalArticleLinks);
	},

	beforeUnmount() {
		document.body.removeEventListener('click', this.handleInternalArticleLinks);
	},
}
</script>

<style scoped>
.nav-sidebar {
	position: sticky !important;
	top: 15em;
}

#article-title-section {
	flex-direction: column;
}

#article-back-button {
	width: 100% !important;
}

#article-next-button {
	width: 100% !important;
}

@media(min-width: 768px) {
	#article-title-section {
		flex-direction: row;
	}

	#article-back-button {
		width: auto !important;
	}

	#article-next-button {
		width: auto !important;
	}
}

.nav-sidebar .nav-link {
	color: #0066CC;
	cursor: pointer;
	transition: all 0.2s ease;
	border: 2px solid transparent;
	border-left: none;
	border-right: none;
	border-top: none;
}

.nav-sidebar .nav-link:hover {
	border-color: rgba(0, 102, 204, 0.1);
	transform: translateX(2px);
}

.nav-sidebar .nav-link:active {
	background-color: rgba(0, 102, 204, 0.2);
}

.reactive-top {
	margin-top: 7em;
	position: sticky;
}

.icon-sm {
	min-width: 24px;
	min-height: 24px;
}


@media (min-width: 992px) {
	.reactive-top {
		margin-top: 14em;
		position: sticky;
	}
}

.reactive-padding {
	padding-top: 0em !important;
}

/* Sidebar toggle button styles */
.sidebar-toggle {
	position: relative;
	top: 82px;
	z-index: 10;
	border-top-right-radius: 25% !important;
	border-bottom-right-radius: 25% !important;
	border-top-left-radius: 0% !important;
	border-bottom-left-radius: 0% !important;
	min-width: 30px;
	min-height: 30px;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	transition: all 0.3s ease;
	background-color: #003366;
	fill: #fff;
}

.group-bar {
	z-index: 10;
}

@media (min-width: 992px) {
	.reactive-padding {
		padding-top: 10em;
	}

	.sidebar-toggle {
		top: 35rem;
	}
}


.sidebar-toggle:hover {
	background-color: #014385;
}

.sidebar-toggle.collapsed {
	left: -15px;
	transform: rotate(180deg);
}

.sidebar-toggle .icon {
	width: 16px;
	height: 16px;
}

.scrollable-menu {
	max-height: 12rem;
	overflow-y: auto;
}

.footer-question {
	margin-top: 2rem;
	background: linear-gradient(135deg, #1e3c72, #2a5298);
	padding: 2rem 0;
}

.popup-box {
	background: white;
	border-radius: 12px;
	border: 1px solid #ddd;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	max-width: 500px;
	margin: auto;
}

.fade-in {
	animation: fadeIn 0.3s ease forwards;
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(10px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.loading-overlay {
	z-index: 1000;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 0.8);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-size: 1.5rem;
	font-weight: bold;
	color: #333;
}

/* Diff viewer — :deep() necessario per stili su elementi iniettati da v-html in contesto scoped */
.diff-content :deep(ins) {
	color: rgb(63, 140, 43);
	background-color: #eaffea;
	text-decoration: none;
	font-weight: bold;
}

.diff-content :deep(del) {
	color: #AA3333;
	background-color: #ffeaea;
	text-decoration: line-through;
}

.diff-content :deep(del.diffimg.diffsrc) {
	display: inline-block;
	position: relative;
}

.diff-content :deep(del.diffimg.diffsrc:before) {
	position: absolute;
	content: "";
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: repeating-linear-gradient(
		to left top,
		rgba(255, 0, 0, 0),
		rgba(255, 0, 0, 0) 49.5%,
		rgba(255, 0, 0, 1) 49.5%,
		rgba(255, 0, 0, 1) 50.5%
	), repeating-linear-gradient(
		to left bottom,
		rgba(255, 0, 0, 0),
		rgba(255, 0, 0, 0) 49.5%,
		rgba(255, 0, 0, 1) 49.5%,
		rgba(255, 0, 0, 1) 50.5%
	);
}

.diff-content :deep(.diff-list) {
	list-style: none;
	counter-reset: section;
	display: table;
}

.diff-content :deep(.diff-list > li.normal),
.diff-content :deep(.diff-list > li.removed),
.diff-content :deep(.diff-list > li.replacement) {
	display: table-row;
}

.diff-content :deep(.diff-list > li > div) {
	display: inline;
}

.diff-content :deep(.diff-list > li.replacement:before),
.diff-content :deep(.diff-list > li.new:before) {
	color: #333333;
	background-color: #eaffea;
	text-decoration: none;
}

.diff-content :deep(.diff-list > li.removed:before) {
	counter-increment: section;
	color: #AA3333;
	background-color: #ffeaea;
	text-decoration: line-through;
}

.diff-content :deep(.diff-list > li.normal:before),
.diff-content :deep(.diff-list > li.removed:before),
.diff-content :deep(.diff-list > li.replacement:before) {
	width: 15px;
	overflow: hidden;
	content: counters(section, ".") ". ";
	display: table-cell;
	text-indent: -1em;
	padding-left: 1em;
}

.diff-content :deep(.diff-list > li.normal:before),
.diff-content :deep(li.replacement + li.replacement:before),
.diff-content :deep(.diff-list > li.replacement:first-child:before) {
	counter-increment: section;
}

.diff-content :deep(ul.exception),
.diff-content :deep(ul.exception li:before) {
	list-style: none;
	content: none;
}

.diff-content :deep(.diff-list ul.exception ol) {
	list-style: none;
	counter-reset: exception-section;
}

.diff-content :deep(.diff-list ul.exception ol > li:before) {
	counter-increment: exception-section;
	content: counters(exception-section, ".") ".";
}
</style>